/**
 * MoonPay specific events.
 */
export var MoonpayEventName;
(function (MoonpayEventName) {
    MoonpayEventName["MOONPAY_GEOCHECK_COMPLETED"] = "MoonPay Geocheck Completed";
    MoonpayEventName["MOONPAY_TRANSACTION_CREATED"] = "MoonPay Transaction Created";
    MoonpayEventName["MOONPAY_TRANSACTION_FAILED"] = "MoonPay Transaction Failed";
    MoonpayEventName["MOONPAY_TRANSACTION_UPDATED"] = "MoonPay Transaction Updated";
})(MoonpayEventName || (MoonpayEventName = {}));
